import filterObjectProperties from "../../__internal__/filter-object-properties";
export const paddingNames = ["p", "padding"];
export const paddingLeftPropertyNames = ["pl", "paddingLeft"];
export const paddingRightPropertyNames = ["pr", "paddingRight"];
export const paddingXPropertyNames = ["px", "paddingX"];
const paddingHorizontalPropertyNames = [...paddingLeftPropertyNames, ...paddingRightPropertyNames, ...paddingXPropertyNames];
export const paddingTopPropertyNames = ["pt", "paddingTop"];
export const paddingBottomPropertyNames = ["pb", "paddingBottom"];
export const paddingYPropertyNames = ["py", "paddingY"];
const paddingVerticalPropertyNames = [...paddingTopPropertyNames, ...paddingBottomPropertyNames, ...paddingYPropertyNames];
export const paddingPropertyNames = [...paddingNames, ...paddingHorizontalPropertyNames, ...paddingVerticalPropertyNames];
export default function filterStyledSystemPaddingProps(props) {
  return filterObjectProperties(props, paddingPropertyNames);
}